import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  AfterViewInit,
} from '@angular/core';
import { Project } from 'app/modules/projects/projects.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { UserService } from 'app/layout/common/user/user.service';
import { AccountService, PusherService } from 'app/core';
import { Account } from 'app/core/models/account.types';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ProjectChanges } from 'app/core/models/pusher';

@Component({
  selector: 'project-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsDetailsComponent extends OnDestroyMixin implements OnInit, AfterViewInit, OnDestroy {
  project: Project;
  account: Account;

  panels = [
    [
      {
        type: 'form',
        title: 'Main Info',
        meta: {},
      },
      {
        type: 'images',
        title: 'Gallery',
        meta: {},
      },
    ],
    [
      {
        type: 'tasks',
        title: 'Tasks',
        meta: {},
      },
      {
        type: 'files',
        title: 'Recent Files',
        meta: {},
      },
      {
        type: 'notes',
        title: 'Notes',
        meta: {},
      },
    ],
    [
      {
        type: 'map',
        title: 'Locations',
        meta: {},
      },

      {
        type: 'form',
        title: 'Deal Overview',
        meta: {},
      },
    ],
  ];

  private get channelName(): string {
    return `Project-${this.project.id}`;
  }

  /**
   * Constructor
   */
  constructor(
    private _projectsService: ProjectsService,
    private _userService: UserService,
    private _accountService: AccountService,
    private _changeDetectorRef: ChangeDetectorRef,
    private readonly pusherService: PusherService,
  ) {
    super();

    this._accountService.currentAccount.subscribe((accountData) => (this.account = accountData));
  }

  ngOnInit(): void {
    this._projectsService.project$.pipe(untilComponentDestroyed(this)).subscribe((project: Project) => {
      this.project = project;
      this._userService.getRecentProjects(this.account.id).subscribe();
      if (project.template?.id) this._projectsService.getProjectTemplateById(project.template.id).subscribe();
      // Mark for check
      this._changeDetectorRef.markForCheck();
    });

    this.pusherService
      .listenToChannel({ channelName: this.channelName, eventName: 'update' })
      .pipe(untilComponentDestroyed(this))
      .subscribe(({ project }: ProjectChanges<Project>) =>
        this._projectsService.setNextProjectValue({
          ...this.project,
          ...project,
        }),
      );
  }

  ngOnDestroy(): void {
    this.pusherService.closeChannel(this.channelName);
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {}
}
